import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import relativeTime from "dayjs/plugin/relativeTime";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);
dayjs.extend(relativeTime);
// isoWeek = Monday-start weeks (startOf/endOf("isoWeek")); used by the report
// wizard's "this week" / "last week" presets.
dayjs.extend(isoWeek);
// customParseFormat makes the FORMAT argument of dayjs(str, fmt) meaningful.
// Without it dayjs silently ignores the format and falls back to `new Date(str)`,
// which parses a non-ISO string as BROWSER-LOCAL — so a UTC wall-clock string
// round-tripped through a format (the Show Performance "Date & Time" column does
// exactly this) lands on an instant shifted by the viewer's UTC offset (PUN-4655).
// Plugins register on the shared dayjs singleton, so this used to be supplied by
// an incidental `dayjs.extend(customParseFormat)` in @punchup/data/legacy/shows —
// correctness must not depend on which unrelated module a bundle happens to pull.
dayjs.extend(customParseFormat);

// Re-exported so consumers can type values without re-deriving
// `ReturnType<typeof dayjs>` at every call site.
export type { Dayjs } from "dayjs";

export default dayjs;
